module.exports = __webpack_public_path__ + "img/program-kemoclub_1.f210dec4.jpg";